export default "__VITE_ASSET__mYxlpPh6__"